import script from "./TrendChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendChart.vue?vue&type=script&setup=true&lang=ts"

import "./TrendChart.vue?vue&type=style&index=0&id=738955d9&lang=scss"

const __exports__ = script;

export default __exports__